/**
 * @file Re-exports the import modal as the package's default export.
 */
import ImportModal from "./ImportModal";

export default ImportModal;
